import React from 'react'
import ImageDownloadIcon from '@mui/icons-material/FileDownloadRounded';
import { colors } from '../../../../../../styles/_var';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/AddRounded';
import Box from '@mui/material/Box'
import TableIcon from '@mui/icons-material/TableChartRounded';


type ActionButtonsProps = {
  hasWinner: boolean,
  onClickDownload: () => void,
  onClickAddIcon: () => void,
  onClickViewScoreboard?: () => void,
  showAddButton?: boolean,
}

const ActionButtons = ({ onClickAddIcon, onClickDownload, hasWinner, onClickViewScoreboard, showAddButton = true }: ActionButtonsProps) => {
  return (
    <Box display="flex">
      {showAddButton && (
        <IconButton onClick={onClickAddIcon} sx={{background: colors.lightgrey}}>
          <AddIcon fontSize="medium" />
        </IconButton>
      )}
      {hasWinner && (
        <IconButton 
          onClick={onClickDownload}
          sx={{background: colors.lightgrey, marginLeft: 1}}
        >
          <ImageDownloadIcon fontSize="medium" />
        </IconButton>
      )}
      {onClickViewScoreboard && (
        <IconButton onClick={onClickViewScoreboard} sx={{background: colors.lightgrey, marginLeft: 1}}>
          <TableIcon fontSize="medium" />
        </IconButton>
      )}
    </Box>
  )
}

export default ActionButtons
